export default "\n<div class =\"loading\">\n  <div class=\"message\">{{message}}</div>\n  <mat-spinner></mat-spinner>\n</div>";